import React from 'react';
import Button from '../../components/common/Button/Button';
import styles from './AddLeadCampaign.module.css';

// Confirm step before removing an image from the media library. The backend still
// refuses (409) when a campaign is using it, so this is a courtesy check.
const DeleteAssetDialog = ({ deleting, onCancel, onConfirm }) => (
    <div className={styles.confirmOverlay} onClick={() => { if (!deleting) onCancel(); }}>
        <div className={styles.confirmCard} onClick={(e) => e.stopPropagation()}>
            <h2 className={styles.confirmTitle}>Delete Image</h2>
            <p className={styles.confirmText}>
                Delete this image from the library? This action cannot be undone.
            </p>
            <div className={styles.confirmActions}>
                <Button variant="secondary" onClick={onCancel} disabled={deleting}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm} loading={deleting} disabled={deleting}>
                    Delete
                </Button>
            </div>
        </div>
    </div>
);

export default DeleteAssetDialog;
